import React from 'react';
export default () =>
	<svg width="16px" height="9px" viewBox="0 0 16 9" version="1.1" xmlns="http://www.w3.org/2000/svg" >

			<defs></defs>
			<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="down-arrow" transform="translate(1.000000, 0.000000)" stroke="currentcolor" strokeWidth="2">
							<polyline id="Shape" points="14.286 0.718 7.203 7.8 0.121 0.718"></polyline>
					</g>
			</g>
	</svg>


// WEBPACK FOOTER //
// ./src/svg/down-arrow.js